const TypingIndicator = () => (
  <div
    className="self-start flex items-center gap-[5px] bg-white border border-gray-200 px-4 py-3 rounded-2xl"
    style={{ borderRadius: '16px 16px 16px 4px' }}
  >
    <span
      className="w-[6px] h-[6px] rounded-full bg-gray-400"
      style={{ animation: 'hp-bounce 1.2s infinite', animationDelay: '0s' }}
    />
    <span
      className="w-[6px] h-[6px] rounded-full bg-gray-400"
      style={{ animation: 'hp-bounce 1.2s infinite', animationDelay: '0.15s' }}
    />
    <span
      className="w-[6px] h-[6px] rounded-full bg-gray-400"
      style={{ animation: 'hp-bounce 1.2s infinite', animationDelay: '0.3s' }}
    />
  </div>
);

export default TypingIndicator;
